module.exports = __webpack_public_path__ + "assets/7dbaf406babbcbbf86fd69186942ea00.png";